import { EncryptMsg, DecryptMsg } from './SecureInfo.js';

function funcEncryptData (message) {
  var classEncrypt = new EncryptMsg();
  var strMessage = JSON.stringify(message);
  var objEncrypt = classEncrypt.getEncryptionInfo(strMessage);
  var strEncrypt = JSON.stringify(objEncrypt);
  return strEncrypt;
}
function funcDecryptData (jsonResult) {
  let classDecrypt = new DecryptMsg();
  let isChecksumPass = classDecrypt.checksum_data(jsonResult.Data, jsonResult.CheckSum);
  if (!isChecksumPass) {
    return { 'ErrorCode': 20001, 'ErrirMessage': 'Decryption CheckSum Error.' };
  }
  let jsonDecryptResult = classDecrypt.getDecryptionInfo(jsonResult);
  return jsonDecryptResult;
}

export { funcEncryptData, funcDecryptData };
